function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable import/max-dependencies */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { Hidden } from '@mediahuis/chameleon-react';
import getDomainInfo from './utils/getDomainInfo';
import getTodaysOpeningHours from './utils/getTodaysOpeningHours';
import getStatus from './utils/getStatus';
import getText from './utils/getText';
import buildContactItem from './utils/buildContactItem';
import Header from './Header';
import Footer from './Footer';
import openNormalChat from './utils/openNormalChat';
import { CHAT, EMAIL, PHONE, STATUSES } from './enums';
import localSettings from './data/localSettings.json';
import Chatbot from './Chatbot';
import validateOpeninghours from './utils/validateOpeningHours';
import getPublicHolidayName from './utils/getPublicHolidayName';
import { ABOSHOP, ELOKET } from '../constants';
import { jsonMainSettings } from './data';
import { getSubscriptionUrl } from '../../utils/config-helper';
var LiveChatWrapper = styled.div.withConfig({
  displayName: "CustomerServiceWidget__LiveChatWrapper",
  componentId: "sc-9me90r-0"
})(["position:fixed;z-index:10;bottom:-5px;right:", ";margin:", ";width:", ";max-width:", ";"], isMobile ? '0' : '2%', isMobile ? '0' : '0 20px 0 0', isMobile && '100%', !isMobile && '380px');

var CustomerServiceWidget = function CustomerServiceWidget(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? '' : _ref$position,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$dropdownAlignmen = _ref.dropdownAlignment,
      dropdownAlignment = _ref$dropdownAlignmen === void 0 ? 'left' : _ref$dropdownAlignmen,
      _ref$chatIsOpen = _ref.chatIsOpen,
      chatIsOpen = _ref$chatIsOpen === void 0 ? false : _ref$chatIsOpen,
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? ELOKET : _ref$destination,
      config = _ref.config;

  var _useState = useState(true),
      isOnline = _useState[0],
      setIsOnline = _useState[1];

  var _useState2 = useState(false),
      isHoliday = _useState2[0],
      setIsHoliday = _useState2[1];

  var _useState3 = useState(false),
      isChatbotActive = _useState3[0],
      setIsChatbotActive = _useState3[1];

  var _useState4 = useState(true),
      isScriptLoading = _useState4[0],
      setIsScriptLoading = _useState4[1];

  var _useState5 = useState({
    dToday: new Date(),
    domainInfo: getDomainInfo(config.siteUrl.split('.')[0], getSubscriptionUrl(config)),
    chat: {
      bChatActive: false,
      link: "https://livechat." + config.siteUrl
    },
    phone: {},
    email: {},
    jsonSettings: {}
  }),
      customerServiceState = _useState5[0],
      setCustomerServiceState = _useState5[1];

  var _useState6 = useState(false),
      isChatWindowOpen = _useState6[0],
      setIsChatWindowOpen = _useState6[1];

  var _useState7 = useState(false),
      isChatbot = _useState7[0],
      setIsChatbot = _useState7[1];

  var dToday = customerServiceState.dToday,
      domainInfo = customerServiceState.domainInfo,
      chat = customerServiceState.chat,
      email = customerServiceState.email,
      phone = customerServiceState.phone;
  var types = [PHONE, CHAT, EMAIL];

  var openLiveChat = function openLiveChat(_ref2) {
    var _ref2$openAfterHours = _ref2.openAfterHours,
        openAfterHours = _ref2$openAfterHours === void 0 ? false : _ref2$openAfterHours;
    openNormalChat({
      link: "" + chat.link,
      user: user,
      openAfterHours: openAfterHours
    });
    setIsChatWindowOpen(true);
  };

  var openChatbot = function openChatbot() {
    setIsChatWindowOpen(true);
    setIsChatbotActive(true);
  };

  var openChat = function openChat() {
    if (!isChatWindowOpen) {
      var chatSettings = customerServiceState.jsonSettings.chat;

      if (!(chatSettings != null && chatSettings.closed)) {
        var isValidDaytime = validateOpeninghours(chatSettings == null ? void 0 : chatSettings.openinghours.hours);
        var openAfterHours = chatSettings == null ? void 0 : chatSettings.openafterhours;

        if (isChatbot && isValidDaytime && !isHoliday) {
          openChatbot();
        } else if (isValidDaytime && !isHoliday) {
          openLiveChat({
            openAfterHours: false
          });
        } else if (openAfterHours) {
          openLiveChat({
            openAfterHours: openAfterHours
          });
        }
      }
    }
  };

  var openPhone = function openPhone() {
    var phoneSettings = customerServiceState.jsonSettings.phone;

    if (!(phoneSettings != null && phoneSettings.closed)) {
      window.open(phone.link, '_self');
    }
  }; // Event handler for Live Chat.


  var receiveMessage = function receiveMessage(event) {
    if (event.data === 'chatStopped') {
      // If iFrame sends message with 'chatStopped',
      // then remove iFrame from DOM.
      var parentFrame = document.getElementById('livechat');
      var childFrame = document.getElementById('iframeLivechat');
      parentFrame.removeChild(childFrame);
      setIsChatWindowOpen(false);
    }
  }; // Build widget contact items.


  var setContactItems = function setContactItems(_ref3) {
    var _extends2;

    var widgetData = _ref3.widgetData;
    var contactElement = types.map(function (type) {
      var lowerCaseType = type.toLowerCase();
      var objContactData = widgetData.jsonSettings[lowerCaseType];
      var todaysopeninghours = getTodaysOpeningHours({
        openingHours: widgetData.jsonSettings[lowerCaseType].openinghours.hours,
        dToday: dToday
      });
      var strStatus = getStatus({
        strType: type,
        todaysopeninghours: todaysopeninghours,
        isClosed: objContactData.closed,
        openinghours: objContactData.openinghours,
        dToday: dToday,
        widgetData: widgetData
      });
      var objDisplay = getText({
        strType: type,
        strStatus: strStatus,
        todaysopeninghours: todaysopeninghours,
        objContactData: objContactData,
        bSubscriptionpage: domainInfo.subscriptionpage,
        dToday: dToday,
        widgetData: widgetData
      });
      var contactData = {
        output: {
          type: type,
          status: strStatus,
          subscriptionpage: domainInfo.subscriptionpage,
          display: objDisplay
        },
        contactdetails: domainInfo[lowerCaseType],
        settings: objContactData
      };
      var itemVisibilitySettings = buildContactItem({
        data: contactData
      });

      var updatedContactData = _extends({}, contactData, itemVisibilitySettings);

      return updatedContactData;
    }); // Must update out of .map because setCustomerServiceState
    // is to slow for mapper.

    setCustomerServiceState(_extends({}, customerServiceState, (_extends2 = {}, _extends2[types[0].toLowerCase()] = contactElement[0], _extends2[types[1].toLowerCase()] = contactElement[1], _extends2[types[2].toLowerCase()] = contactElement[2], _extends2.jsonSettings = widgetData.jsonSettings, _extends2))); // Check status of global active/inactive icon.

    var allStatusses = contactElement.map(function (element) {
      if (element.mayShow) {
        switch (element.output.status) {
          case STATUSES.CLOSED:
          case STATUSES.HOLIDAY:
          case STATUSES.OPENSOON:
          case STATUSES.RESTDAY:
          case STATUSES.CHATBOT:
            return 'closed';

          default:
            return 'open';
        }
      }

      return null;
    });
    var isClosed = allStatusses.every(function (value) {
      return value === 'closed' || value === null;
    });

    if (isClosed) {
      setIsOnline(false);
    } else if (!isOnline) {
      setIsOnline(true);
    } // Logic should run every so often to be as much up to date
    // with opening / closing hours of the services.


    if (jsonMainSettings.autoUpdate.active) {
      setTimeout(function () {
        setContactItems({
          widgetData: widgetData
        });
      }, jsonMainSettings.autoUpdate.interval * 1000);
    }
  };

  var getFetchUrl = function getFetchUrl() {
    var apiPrefix = config.apiPrefix || 'production';

    if (MH_BRAND === BRANDS.DL && destination === ABOSHOP) {
      return "https://mh-subscriber-settings.s3.eu-west-1.amazonaws.com/public/" + apiPrefix + "/" + ABOSHOP + "/" + MH_BRAND + "/customer-service-widget.json";
    } else if (MH_BRAND === BRANDS.DL && destination === ELOKET) {
      return "https://mh-subscriber-settings.s3.eu-west-1.amazonaws.com/public/" + apiPrefix + "/" + ELOKET + "/" + MH_BRAND + "/customer-service-widget.json";
    }

    return "https://mh-subscriber-settings.s3.eu-west-1.amazonaws.com/public/" + apiPrefix + "/" + MH_BRAND + "/customer-service-widget.json";
  };

  useEffect(function () {
    // Get widget settings.
    fetch(getFetchUrl()).then(function (response) {
      return response.json();
    }).then(function (data) {
      var _data$jsonSettings, _chatSettings$opening, _data$jsonSettings2, _data$jsonSettings2$s, _data$jsonSettings2$s2;

      var chatSettings = (data == null ? void 0 : (_data$jsonSettings = data.jsonSettings) == null ? void 0 : _data$jsonSettings.chat) || {};
      var queryParams = new URLSearchParams(window.location.search);
      var isOpenQueryParam = queryParams.get('chat');
      var isOpen = chatSettings.isOpen || isOpenQueryParam;
      var isValidDayTime = validateOpeninghours((_chatSettings$opening = chatSettings.openinghours) == null ? void 0 : _chatSettings$opening.hours);
      var holidayName = getPublicHolidayName({
        dToday: customerServiceState.dToday,
        widgetData: data
      });
      setIsHoliday(holidayName);
      setContactItems({
        widgetData: data
      }); // Check if chatbot is active, if not fallback to livechat

      if ((_data$jsonSettings2 = data.jsonSettings) != null && (_data$jsonSettings2$s = _data$jsonSettings2.settings) != null && (_data$jsonSettings2$s2 = _data$jsonSettings2$s.chatbot) != null && _data$jsonSettings2$s2.active) {
        // Load Chatbot script and set isChatbot to true
        setIsChatbot(true);
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = // eslint-disable-next-line no-template-curly-in-string
          "https://" + config.apiPrefix + "ifr-chatbot." + config.siteUrl + "/js/chatbot.js?v=" + chatSettings.chatbotScriptVersion;
          script.async = true;
          script.addEventListener('load', function () {
            setIsScriptLoading(false);
            resolve(script);

            if (!holidayName && isOpen && chatIsOpen && isValidDayTime && !chatSettings.closed && chatSettings.visible) {
              openChatbot();
            }
          });
          script.addEventListener('error', function (e) {
            reject(e);
          });
          document.body.appendChild(script);
        });
      }

      if (!holidayName && isOpen && chatIsOpen && !chatSettings.closed && chatSettings.visible && isValidDayTime) {
        openLiveChat({
          openAfterHours: false
        });
      }

      return data;
    }).catch(function (ex) {
      console.error(ex); // If API call fails set local widget data file as values.

      setContactItems({
        widgetData: localSettings
      });
    }); // EventListener which listens to Chatbot iFrame messages.

    window.addEventListener('message', receiveMessage, false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // TODO:: check what happens when you have footer and header
  // render so that live chat does not render twice.

  if (position === 'footer') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Footer, {
      title: title,
      chat: chat,
      email: email,
      phone: phone,
      openChat: openChat,
      openPhone: openPhone
    }), /*#__PURE__*/React.createElement(LiveChatWrapper, {
      id: "livechat"
    }), /*#__PURE__*/React.createElement(Hidden, {
      screen: !isChatbotActive
    }, /*#__PURE__*/React.createElement(Chatbot, {
      isScriptLoading: isScriptLoading,
      setIsChatbotActive: setIsChatbotActive,
      setIsChatWindowOpen: setIsChatWindowOpen
    })));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: title,
    chat: chat,
    email: email,
    phone: phone,
    isOnline: isOnline,
    openChat: openChat,
    dropdownAlignment: dropdownAlignment,
    openPhone: openPhone
  }), /*#__PURE__*/React.createElement(LiveChatWrapper, {
    id: "livechat"
  }), /*#__PURE__*/React.createElement(Hidden, {
    screen: !isChatbotActive
  }, /*#__PURE__*/React.createElement(Chatbot, {
    isScriptLoading: isScriptLoading,
    setIsChatbotActive: setIsChatbotActive,
    setIsChatWindowOpen: setIsChatWindowOpen
  })));
};

export default CustomerServiceWidget;